import { Box, Button, ButtonGroup, Container, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import ModalLoadingFull from "../../../../components/modals/ModalLoadingFull";
import EventCreationGameStore from "./EventCreationSteps/EventCreationGameStore";
import EventCreationGameSystem from "./EventCreationSteps/EventCreationGameSystem";
import EventCreationEventDetails from "./EventCreationSteps/EventCreationEventDetails";
import EventCreationGameConfiguration from "./EventCreationSteps/EventCreationGameConfiguration";
import EventCreationRegistraion from "./EventCreationSteps/EventCreationRegistraion";
import {
  BCPLockKeyhole,
  BCPLockKeyholeOpen,
} from "../../../../components/icons/bcp/BCPIcons";
import EventCreationCircuits from "./EventCreationSteps/EventCreationCircuits";
import { useState } from "react";
import { AdminOptionsMenu } from "../SubComponents/EventAdminMenus";

export default function EventCreationDefault(props) {
  const {
    event,
    eventId,
    loading,
    copyId,
    step,
    setStep,
    gameStores,
    gameSystem,
    processing,
    headerRef,
    headerInView,
    EventHeader,
    navigate,
    confirm,
    readOnly,
    setReadOnly,
    authContext,
    setCircuits,
    circuits,
  } = props;

  const { t } = useTranslation("translation", {
    keyPrefix: "components.eventCreation"
  });

  const [adminOptionsAnchorEl, setAdminOptionsAnchorEl] = useState(null);

  return (
    <Container sx={{ pb: 2, pl: 2, pr: 2, pt: "50px" }} maxWidth="lg">
      {/* UI/Nav/Header */}
      <Grid container>
        <Grid
          item
          xs={12}
          sx={{
            pb: 1,
            mt: -4,
            mb: 1,
            borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
          }}
          ref={headerRef}
        >
          {!loading && (
            <EventHeader
              step={step}
              setStep={setStep}
              copyId={copyId}
              gameSystem={gameSystem}
              gameStores={gameStores}
              confirm={confirm}
              navigate={navigate}
              event={event}
              circuits={circuits}
              setCircuits={setCircuits}
            />
          )}
        </Grid>
      </Grid>

      {!headerInView && (
        <Box
          sx={{
            position: "fixed",
            zIndex: 999,
            p: 2,
            pt: 1,
            pb: 0,
            bgcolor: "background.secondary",
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            boxShadow: 3,
            top: ["50px", "60px"],
            left: [0, 0, 0, 256],
            width: ["100%", "100%", "100%", "calc(100% - 256px)"],
          }}
        >
          <EventHeader
            step={step}
            setStep={setStep}
            eventId={eventId || event?.id}
            copyId={copyId}
            gameSystem={gameSystem}
            gameStores={gameStores}
            confirm={confirm}
            navigate={navigate}
            setCircuits={setCircuits}
          />
        </Box>
      )}

      {/* Main body */}
      <Grid container>
        {/* Admin lock/unlock button */}
        {(authContext?.authState?.identity?.isAdmin === true ||
          authContext?.authState?.identity?.adminGameSystems?.includes(
            event?.gameSystemId
          )) && (
          <Grid
            item
            xs={12}
            sx={{
              p: 2,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            }}
          >
            <ButtonGroup fullWidth>
              <Button
                color="primary"
                variant="contained"
                onClick={() => {
                  setReadOnly(!readOnly);
                }}
                endIcon={
                  readOnly ? (
                    <BCPLockKeyhole
                      outlined
                      style={{
                        "font-size": "18px",
                        width: "18px",
                      }}
                    />
                  ) : (
                    <BCPLockKeyholeOpen
                      outlined
                      style={{
                        "font-size": "18px",
                        width: "18px",
                      }}
                    />
                  )
                }
              >
                {readOnly ? t("locked") : t("unlocked")}
              </Button>
              <Button
                color="primary"
                variant="outlined"
                ariaExpanded={Boolean(adminOptionsAnchorEl) ? true : undefined}
                onClick={(e) => {
                  setAdminOptionsAnchorEl(e.currentTarget);
                }}
                disabled={readOnly}
              >
                {t("adminOptions")}
              </Button>
            </ButtonGroup>
            <AdminOptionsMenu
              anchorEl={adminOptionsAnchorEl}
              setAnchorEl={setAdminOptionsAnchorEl}
              event={event}
              authContext={authContext}
            />
          </Grid>
        )}

        {/* Gamestore/Organization Picker */}
        {step === 0 && !loading && <EventCreationGameStore {...props} />}

        {/* GameSystemPicker */}
        {step === 1 && !loading && <EventCreationGameSystem {...props} />}

        {/* Event Details */}
        {step === 2 && !loading && <EventCreationEventDetails {...props} />}

        {/* Game Configuration */}
        {step === 3 && !loading && (
          <EventCreationGameConfiguration {...props} />
        )}

        {/* Registration & Ticketing */}
        {step === 4 && !loading && <EventCreationRegistraion {...props} />}

        {/* Circuits */}
        {step === 5 && !loading && <EventCreationCircuits {...props} />}
      </Grid>

      {(loading || processing) && <ModalLoadingFull />}
    </Container>
  );
}
